export default __webpack_public_path__ + "static/media/i-close.ecb0875a.svg";